import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/layout/Sidebar';
import PageContainer from '../../components/layout/PageContainer';
import { useAuth } from '../../hooks/useAuth';
import Overview from './Overview';
import MyTicketsView from './MyTicketsView';
import WorkReportView from './WorkReportView';
import ChecklistView from './ChecklistView';
import KnowledgeBaseView from './KnowledgeBaseView'; // ← ADD THIS
import ScheduleManagementView from './ScheduleManagementView';
import SettingsView from './SettingsView';

const EngineerDashboard = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [ticketFilter, setTicketFilter] = useState('');
  const [prefilledWorkReportTicket, setPrefilledWorkReportTicket] = useState(null);

  const handleOpenWorkReportFromTicket = (ticket) => {
    if (!ticket?.id) {
      return;
    }

    setPrefilledWorkReportTicket(ticket);
    navigate('/engineer/reports');
  };

  const pages = [
    { id: 'dashboard', name: 'Dashboard', icon: 'dashboard' },
    { id: 'tickets', name: 'My Tickets', icon: 'tickets' },
    { id: 'schedule-management', name: 'Schedule Management', icon: 'scheduleManagement' },
    { id: 'reports', name: 'Work Reports', icon: 'reports' },
    // { id: 'checklist', name: 'Checklists', icon: 'checklist' },
    { id: 'knowledge', name: 'Knowledge Base', icon: 'knowledge' }, // ← ADD THIS
    { id: 'settings', name: 'Settings', icon: 'settings' }
  ];

  const containerStyle = {
    display: 'flex',
    minHeight: '100vh',
    background: 'var(--background)'
  };

  const pageSegment = location.pathname.split('/')[2] || 'dashboard';
  const currentPage = pages.some((page) => page.id === pageSegment) ? pageSegment : 'dashboard';

  const setCurrentPage = (pageId) => {
    setTicketFilter(''); 
    navigate(`/engineer/${pageId}`);
  };

  const navigateToMyTickets = (filter = '') => {
    setTicketFilter(filter);
    navigate('/engineer/tickets');
  };

  const mainContentStyle = {
    flex: 1,
    marginLeft: sidebarOpen ? '260px' : '80px',
    transition: 'margin-left 0.3s ease',
    minHeight: '100vh'
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Overview onStartWorkNavigate={handleOpenWorkReportFromTicket} navigateToMyTickets={navigateToMyTickets}/>;
      case 'tickets':
        return <MyTicketsView onStartWorkNavigate={handleOpenWorkReportFromTicket} defaultFilter={ticketFilter}/>;
      case 'schedule-management':
        return <ScheduleManagementView />;
      case 'reports':
        return (
          <WorkReportView
            prefilledTicket={prefilledWorkReportTicket}
            onPrefillConsumed={() => setPrefilledWorkReportTicket(null)}
          />
        );
      case 'checklist':
        return <ChecklistView />;
      case 'knowledge':
        return <KnowledgeBaseView />; // ← ADD THIS
      case 'settings':
        return <SettingsView />;
      default:
        return <Overview />;
    }
  };

  const getPageTitle = () => {
    const page = pages.find(p => p.id === currentPage);
    return page?.name || 'Dashboard';
  };

  const getPageSubtitle = () => {
    const subtitles = {
      dashboard: 'Your daily performance overview',
      tickets: 'Manage your assigned tickets',
      'schedule-management': 'View-only ordered list of scheduled tickets',
      reports: 'Submit and manage work completion reports',
      checklist: 'Standard procedures and checklists',
      knowledge: 'Resources and guides for field work', // ← ADD THIS
      settings: 'Manage your account settings'
    };
    return subtitles[currentPage] || '';
  };

  return (
    <div style={containerStyle}>
      <Sidebar
        user={user}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pages={pages}
        onLogout={logout}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      />
      <div style={mainContentStyle}>
        <PageContainer
          title={getPageTitle()}
          subtitle={getPageSubtitle()}
        >
          {renderPage()}
        </PageContainer>
      </div>
    </div>
  );
};

export default EngineerDashboard;